import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from '../api/aws/useUser'
import { useValidateGoogleToken } from '../api/google/useValidateGoogleToken'

const ProtectedRoute = ({ children }) => {
  const { validateToken, isValid, accessToken, refreshed } = useValidateGoogleToken()
  const { user: currentUser, isUserLoading } = useUser(localStorage.getItem('slack_user_id'))

  const [_checking, setChecking] = useState(true)
  console.log('[ProtectedRoute] import.meta.env.VITE_ENV', import.meta.env.VITE_ENV)
  const googleAccessToken = localStorage.getItem('google_access_token')
  const slackAccessToken = localStorage.getItem('slack_access_token')
  const pandaAccessToken =
    import.meta.env.VITE_ENV === 'local' || import.meta.env.VITE_ENV === 'laptop'
      ? '44c682867cd90875b3ba53db7280c56e1a4d6068'
      : localStorage.getItem('panda_access_token')

  const allTokensPresent = googleAccessToken && slackAccessToken && pandaAccessToken

  useEffect(() => {
    if (isUserLoading) return // Don't run token validation if user data isn't loaded yet

    const verifyGoogleToken = async () => {
      if (!googleAccessToken) {
        setChecking(false)
        return
      }

      // Validate Google token only when user data is available
      validateToken({
        accessToken: googleAccessToken,
        refreshToken: currentUser?.googleRefreshToken, // This should be available now
        userId: localStorage.getItem('slack_user_id'),
      })
    }

    verifyGoogleToken()
  }, [validateToken, currentUser, isUserLoading]) // Depend on currentUser and isUserLoading

  useEffect(() => {
    if (refreshed && accessToken) {
      localStorage.setItem('google_access_token', accessToken)
    }
    if (isValid) {
      setChecking(false)
    }
  }, [isValid, refreshed, accessToken])

  if (!allTokensPresent) {
    return <Navigate to="/" />
  }

  return children
}

export default ProtectedRoute
